import { render, staticRenderFns } from "./Criar-Turma.vue?vue&type=template&id=286deff8&scoped=true&"
import script from "./Criar-Turma.vue?vue&type=script&lang=js&"
export * from "./Criar-Turma.vue?vue&type=script&lang=js&"
import style0 from "./Criar-Turma.vue?vue&type=style&index=0&id=286deff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286deff8",
  null
  
)

component.options.__file = "Criar-Turma.vue"
export default component.exports